import React, { useEffect, useState } from 'react';
import { DarkGreyIcon, CheckedIcon } from '../Icon/BrigthnessIcon';
import { CircleIcon } from '../Icon/CircleIcon';
import {
  RedRadio
} from '../Icon/RadioButton';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { v4 as uuidv4 } from 'uuid';

interface Props {
  sendSelectedColor: any;
  type: any;
  sessionStorageName: any;
  module?: any;
  infoBulles?: any;
  automatedTestId?: string[];
}

const CONFIG = {
  standard: {
    boxes: ['red', 'orange', 'blue', 'green', 'grey', 'black'],
    iconColors: ['#FE3123', '#FFBF66', '#008BD2', '#76D19B', '#E9E9E9', '#000000'],
  },
  hydro: {
    boxes: ['red', 'orange', 'blue'],
    iconColors: ['#339900', '#0066ff', '#cc00ff'],
    labels: [new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() - 2],
  },
  h2s: {
    boxes: ['red', 'orange', 'green', 'blue', 'grey', 'black'],
    iconColors: ['#FE3123', '#FFBF66', '#76D19B', '#008BD2', '#E9E9E9', '#000000'],
  },
  indus: {
    boxes: ['red', 'orange', 'green', 'grey'],
    iconColors: ['#FE3123', '#FFBF66', '#76D19B', '#E9E9E9'],
  },
  pluie: {
    boxes: ['red', 'blue', 'green', 'grey', 'black'],
    iconColors: ['#FE3123', '#008BD2', '#76D19B', '#E9E9E9', '#000000'],
  },
  ecp: {
    boxes: ['red', 'orange', 'green', 'purple', 'grey', 'black'],
    iconColors: ['#FE3123', '#FFBF66', '#76D19B', '#A500B5', '#E9E9E9', '#000000'],
  },
};

const format = (pColor) => {
  let stateColor;
  if (pColor) {
    stateColor = pColor;
  } else {
    stateColor = false;
  }

  return stateColor;
};

export const createFilterParameter = (pType: string, pSessionStorageName: string, pAutomatedTestId: string[]) => {
  const config = CONFIG[pType];
  const sessionData = JSON.parse(window.sessionStorage.getItem(pSessionStorageName) || '{}');
  const colors = config !== undefined ? config.boxes.reduce((acc, box) => {
    acc[box] = format(sessionData[box]);
    return acc;
  }, {} as Record<string, boolean>) : {};
  const params = config !== undefined ? config.boxes.map((box, index) => ({
    name: box,
    value: colors[box],
    iconColor: config.iconColors[index],
    label: config.labels ? config.labels[index] : undefined,
    automatedTestId: pAutomatedTestId?.[index] || '',
  })) : [];
  return {
    colors,
    params,
  };
};

const DataSelector = (props: Props) => {
  const [color, setColor] = useState<Record<string, boolean>>({});
  const [param, setParam] = useState<object[]>([]);
  const sectionType = window.localStorage.getItem('type');
  const infobulle = props.infoBulles;

  useEffect(() => {
    const { colors, params } = createFilterParameter(
      props.type,
      props.sessionStorageName,
      props.automatedTestId ? props.automatedTestId : []
    );

    setColor(colors);
    setParam(params);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event: any) => {
    setColor({ ...color, [event.target.name]: event.target.checked });
  };

  useEffect(() => {
    (Object.keys(color).length !== 0 &&
      param.length !== 0) &&
      props.sendSelectedColor(color);
  }, [color]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <FormGroup id='radio-check' row style={{}}>
        {(Object.keys(color).length !== 0 && param.length !== 0) &&
          param.map((box: any) => {
            return (
              <div key={uuidv4()}>
                <FormControlLabel
                  id={
                    box.automatedTestId !== ''
                      ? box.automatedTestId
                      : sectionType + '-' + box.name
                  }
                  control={
                    <div
                      title={
                        infobulle !== undefined ? infobulle[box.name] : box.name
                      }
                    >
                      <RedRadio
                        icon={<CircleIcon strokeColor={box.iconColor} />}
                        checkedIcon={
                          box.name !== 'grey' ? (
                            <CheckedIcon color={box.iconColor} />
                          ) : (
                            <DarkGreyIcon />
                          )
                        }
                        checked={color[box.name]}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        name={box.name}
                      />
                    </div>
                  }
                  label={box.label}
                  style={{
                    display: 'grid',
                    padding: '4px',
                    fontSize: 'smaller',
                    textAlign: 'center',
                    width: 'auto',
                  }}
                />
              </div>
            );
          })}
      </FormGroup>
    </>
  );
};
export default DataSelector;
